/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {LocalDate} from 'spine-web/proto/spine/time/time_pb';
import LocalDateExt from '@/shell/model/spine/time/LocalDateExt';
import {GroupDef} from '@/shell/lists/GroupDef';

/**
 * An implementation of `GroupDef`, which defines a group that encompasses one calendar day.
 */
export class SingleDayGroupDef extends GroupDef {
  constructor(readonly date: LocalDate) {
    super();
  }

  get id(): string | number {
    return this.date.getYear() + "-" + this.date.getMonth() + "-" + this.date.getDay();
  }

  get title(): string {
    const dateExt = LocalDateExt.of(this.date);
    return dateExt.formatAsRelativeDate();
  }
}
